import Component from '../../js/_Component';

export default class HeaderBoatCard extends Component {
	constructor(element: HTMLElement) {
		super(element);

		this.element.addEventListener('updatecompactmode', (e: CustomEvent) => {
			if (e.detail) {
				this.element.classList.add('m-compact');
			} else {
				this.element.classList.remove('m-compact');
			}
		});
	}
}

Component.register(HeaderBoatCard, 'HeaderBoatCard');
